import { Box, Button, Checkbox, FormControl, FormControlLabel, MenuItem, Pagination, Select, Skeleton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import './stockBalance.scss'
// import api from '../../api/api'
import { useSearchParams } from 'react-router-dom'
// import StockContext from './services/stockApi'
import { getBranchList } from '../setting/services/settingApi'
import { useSelector } from 'react-redux'
import { getData } from '../../services/api'
import { STOCK_CONFIG } from './config'
export default function StockBalance() {
    const [branchs, setBranchs] = useState()
    // const { getAllLotHQ } = useContext(StockContext);
    const [searchParams, setSearchParams] = useSearchParams()
    // const [branchsNo, setBranchsNo] = useState('all')
    const [data, setData] = useState([])
    const [name, setName] = useState('')
    const [lot, setLot] = useState('')
    const [loading, setLoading] = useState(false)
    let branchsNo = searchParams.get('branchsNo') || 'all'
    let q = searchParams.get('q') || ''
    let l = searchParams.get('l') || ''
    let page = searchParams.get('page') || '1'
    let sum = searchParams.get('sum') || 'false'
    const { profile } = useSelector(state => state.profile)

    // const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);

    const getStock = async () => {
        setLoading(true)
        let _params = `&${q ? 'name=' + q + '&' : ''}${l ? l !== 'all' ? 'lot=' + l + '&' : '' : ''}${sum ? 'sumLots=' + sum : ''}`

        await getData(`${STOCK_CONFIG.requests.getLotsBranch.url}/${branchsNo === 'all' ? profile?.BranchNo?.BranchNo : branchsNo}/lots` + `?page=${page}&limit=${rowsPerPage}` + _params).then((response) => {
            if (response.status === true) {
                setData(response.result)
                setLoading(false)
            }
        })
    }
    const getAllLotHQ = async () => {
        setLoading(true)
        let _params = `&${q ? 'name=' + q + '&' : ''}${l ? l !== 'all' ? 'lot=' + l + '&' : '' : ''}${sum ? 'sumLots=' + sum : ''}`
        await getData(STOCK_CONFIG.requests.getAllLotHq.url + `?page=${page}&limit=${rowsPerPage}` + _params).then((response) => {
            if (response.status === true) {
                setData(response.result)
                setLoading(false)
            }
        })
    }

    const handleSearch = (event) => {
        event.preventDefault();

        setSearchParams({ q: name, l: lot, branchsNo: branchsNo, sum: sum })
    }
    useEffect(() => {
        getBranchList(null, setBranchs)

    }, [])
    useEffect(() => {
        if (profile?.BranchNo?.BranchNo === '00' && branchsNo === 'all') {
            getAllLotHQ()
        } else {

            getStock()
        }
        setName(q)
        setLot(l)
    }, [sum, q, l, profile, branchsNo, page])
    // useEffect(() => {
    //     getStock()
    // }, [profile])
    return (
        <Page>
            <div className="container-fluid">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '20px 0px' }}>
                    <div class="col-lg-3 col-md-12 text-left d-flex align-items-center" >
                        <label className="title-content mb-4">
                            รายการเมล็ดพันธุ์คงคลัง
                        </label>
                    </div>
                    <div class="col-lg-9 col-md-12 text-left " style={{ display: 'flex', justifyContent: 'end' }}>

                        <div class="col-lg-2 col-md-6 d-flex align-items-center justify-content-center">
                            <FormControlLabel control={<Checkbox checked={sum === 'true' ? true : false} onChange={e => setSearchParams({ sum: e.target.checked, q: q, l: l, branchsNo: branchsNo })} />} label="รวมรายพันธุ์" />
                        </div>
                        {
                            profile?.BranchNo?.BranchNo === '00' &&
                            <div class="col-lg-2 col-md-12 " style={{marginRight:'10px'}}>
                                <Box className='backgroundField'>
                                    <FormControl variant="standard" fullWidth >
                                        <Select value={branchsNo} onChange={e => setSearchParams({ branchsNo: e.target.value, q: q, l: l, sum: sum })} disableUnderline MenuProps={{
                                            style: {
                                                maxHeight: 400,
                                            },
                                        }}>
                                            <MenuItem value='all'>ทั้งหมด</MenuItem>

                                            {branchs?.map((x, i) => (
                                                <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>

                            </div >
                        }

                        <div class="col-lg-3 col-md-12 text-end" >
                            <Box className='backgroundField' style={{marginRight:'10px'}}>
                                <TextField value={name} onChange={e => setName(e.target.value)} variant="standard" fullWidth placeholder="ค้นหา พันธ์ุ"
                                    InputProps={{ disableUnderline: true }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-3 col-md-12 text-end">
                            <Box className='backgroundField'>
                                <TextField value={lot} onChange={e => setLot(e.target.value)} variant="standard" fullWidth placeholder="ค้นหา เลขที่ล็อต"
                                    InputProps={{ disableUnderline: true }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-2 col-md-1" >
                            <Button className='ButtomSearch' variant='contained' sx={{marginLeft:'10px'}} onClick={handleSearch}>ค้นหา</Button>
                        </div >
                    </div>
                </div >

                <div class="stockBalance row">
                    {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :
                        <div className="col-md-12 table-responsive-sm pb-3">
                            <table class="table table-borderless table-hover ">
                                <thead>
                                    <tr>
                                        <th class="text-center">ที่</th>
                                        {profile?.BranchNo?.BranchNo === '00' && <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>}
                                        <th class="text-center">พันธุ์</th>
                                        <th class="text-center"> ชั้นพันธุ์</th>
                                        <th class="text-center">ฤดู</th>
                                        <th class="text-center">ปี</th>
                                        <th class="text-center">คลุกสาร</th>
                                        {sum !== 'true' && <th class="text-center">ล็อตที่</th>}
                                        <th class="text-center">คงคลัง (กิโลกรัม)</th>
                                        {sum !== 'true' && <th class="text-center">จำนวนวันที่อยู่ในคลัง</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.items?.map((x, i) => (
                                        <tr>
                                            <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                            {profile?.BranchNo?.BranchNo === '00' && <td className="text-center">{x?.BranchNo?.BranchName}</td>}
                                            <td class="text-center">{x?.ItemNo?.CatalogNo?.CatalogName}</td>
                                            <td class="text-center">{x?.ItemNo?.Option2}</td>

                                            <td class="text-center">
                                                <span style={{ fontWeight: "bold", color: x?.Season === 'ฝน' ? '#0D9206' : 'brown' }}> {x?.Season}</span>
                                            </td >
                                            <td class="text-center">{x?.Year}</td>
                                            <td class="text-center">{x?.ItemNo?.Chemical}</td>
                                            {sum !== 'true' && <td class="text-center">{x?.Lot}</td >}
                                            <td class="text-center">{x?.Balance.toLocaleString()}</td>
                                            {sum !== 'true' && <td class="text-center"><span style={{ color: x.DaysInStock > 240 ? '#E82900' : x.DaysInStock <= 180 ? '#000' : '#ECA904' }}>{x?.DaysInStock}</span></td >}
                                        </tr >
                                    ))}

                                </tbody >
                            </table >
                        </div >}
                    <div className="col-md-12 text-center mt-4">
                        <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, q: q, l: l, sum: sum, branchsNo: branchsNo })} shape="rounded" />
                    </div >
                </div >
            </div >
        </Page >
    )
}
